import { render, staticRenderFns } from "./alter.vue?vue&type=template&id=ce4e76e2&scoped=true&"
import script from "./alter.vue?vue&type=script&lang=js&"
export * from "./alter.vue?vue&type=script&lang=js&"
import style0 from "./alter.vue?vue&type=style&index=0&id=ce4e76e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4e76e2",
  null
  
)

export default component.exports